import $ from 'jquery';
import { debounce, isMobile } from './../../utils';
$(function () {
  var $descriptions = $('.resource__description');
  var $imgs = $('.resource__img');
  var $titles = $('.resource__title');
  var maxHeightDescription = 0;
  var maxHeightImg = 0;
  var maxHeightTitle = 0;
  var windowWidth = window.innerWidth;
  if (!$descriptions || !$descriptions.length) {
    return;
  }
  setTimeout(init, 200);
  $(window).on('resize', debounce(onResize, 200));

  ////

  function init() {
    maxHeightDescription = resetHeight(0, $descriptions, 0);
    maxHeightImg = resetHeight(0, $imgs, 0);
    maxHeightTitle = resetHeight(0, $titles, 0);
    $descriptions.css({
      height: maxHeightDescription + 'px'
    });
    $imgs.css({
      height: maxHeightImg + 'px'
    });
    $titles.css({
      height: maxHeightTitle + 'px'
    });
  }
  function onResize() {
    $descriptions.css({
      height: 'auto'
    });
    $imgs.css({
      height: 'auto'
    });
    $titles.css({
      height: 'auto'
    });
    if (isMobile() || windowWidth === window.innerWidth) {
      windowWidth = window.innerWidth;
      return;
    } else {
      windowWidth = window.innerWidth;
    }
    init();
  }
  function resetHeight(index, $elements, maxHeight) {
    var $element = $elements.eq(index);
    var elementHeight = $element.height();
    if (elementHeight > maxHeight) {
      maxHeight = elementHeight;
    }
    index += 1;
    return $elements[index] ? resetHeight(index, $elements, maxHeight) : maxHeight;
  }
});